<template>
  <el-dialog :visible.sync="currentValue" width="720px" custom-class="help-page-search" top="5%" append-to-body :show-close="false">
    <template>
      <div class="head">
        <!-- <el-input v-model="keyword" size="large" placeholder="请输入关键字搜索"></el-input> -->
        <el-autocomplete
          class="inline-input"
          size="large"
          ref="searchInput"
          v-model="keyword"
          :fetch-suggestions="querySearch"
          :popper-class="showAuto ? 'autocompleteVisible' : 'autocompleteDisplay'"
          hide-loading
          @keyup.enter.native="search"
          @select="search"
          @input="searchInput"
          @clear="clearInput"
          :debounce="0"
          clearable
          placeholder="请输入关键词搜索"
          :trigger-on-focus="false"
        ></el-autocomplete>
        <wf-button size="large" @click="search" :disabled="!keyword"><i class="icon iconfont iconicon_search1"></i></wf-button>
      </div>
      <div class="tip" v-if="(searchResult.length === 0 || !keyword) && keywordResult.length > 0 && !isLoading">
        <p class="title">常见搜索</p>
        <div class="content">
          <div class="item" v-for="(item, index) in keywordResult" :key="index" @click="keywordSearch(item)">{{item.keyword}}</div>
        </div>
      </div>
      <div class="result" v-if="isSearch && keyword">
        <p class="title">共找到 {{searchTotal}} 条搜索结果</p>
        <div class="content" v-infinite-scroll="loadNext" :infinite-scroll-distance="20" :infinite-scroll-immediate="false">
          <div class="item" v-for="item in searchResult" :key="item.id" @click="checkDocument(item)">
            <div class="detail-title" >
              <i class="icon iconfont" :class="{[item.icon]: true}" :style="{'color': item.color}"></i>
              <span v-html="item.vtitle"></span>
            </div>
            <div class="detail" v-html="item.document_content_highlight">
            </div>
          </div>
          <div class="nothing-box-c" v-if="isSearch && searchResult.length === 0 && !isLoading">
            <nothing :config="{tip: '暂无搜索结果', type: 'img_search'}" width="160px"></nothing>
          </div>
          <div class="loading-box" v-if="isLoading">
            <i class="el-icon-loading"></i>
          </div>
        </div>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import api from '@/services/api/help/help'
export default {
  props: ['value'],
  data() {
    return {
      keyword: '',
      keywordResult: [],
      searchResult: [],
      showAuto: false,
      searchTotal: 0,
      isSearch: false,
      isLoading: false,
      finish: false,
      limit: 20,
      offset: 0
    }
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    keyword() {
      if(!this.keyword) {
        this.isSearch = false
        this.searchResult = []
      }
    }
  },
  created() {
    this.init()
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.searchInput.focus()
    })
  },
  methods: {
    async querySearch(queryString, cb) {
      if(queryString) {
        this.showAuto = false
        let result = await api.documentSuggestDoc({keyword: queryString})
        let data = result.suggest
        if(data.length > 0) {
          this.showAuto = true
        } else {
          this.showAuto = false
        }
        cb(data.map(res => {
          return {
            value: res
          }
        }))
      } else {
        cb([])
        this.showAuto = false
      }
    },
    async init() {
      let result = await api.documentKeywordsIndex({display_type: 'frontend'})
      this.keywordResult = result.data || []
    },
    search() {
      this.showAuto = false
      if(!this.keyword) return
      this.offset = 0
      this.isLoading = false
      this.finish = false
      this.searchResult = []
      this.load()
    },
    async load() {
      if(this.isLoading || this.finish) return
      this.isLoading = true
      let params = {
        offset: this.offset,
        limit: this.limit,
        keyword: this.keyword,
      }
      let result = await api.documentSearchDoc(params)
      this.isSearch = true
      result.data.map(res => {
        res.id = this.uuid()
      })
      this.searchResult.push(...result.data)
      this.searchTotal = result.total
      if(result.data.length === 0 || this.searchResult.length === result.total) {
        this.finish = true
      }
      this.isLoading = false
    },
    async loadNext() {
      this.offset = this.offset + this.limit
      this.load()
    },
    keywordSearch(item) {
      this.keyword = item.keyword
      this.search()
    },
    checkDocument(item) {
      const newUrl = this.$route.path + `?id=${item.document_draft_id}`
      window.history.replaceState('', '', `${window.location.pathname}#${newUrl}`)
      const _route = Object.assign({}, this.$route);
      _route.query = {
        id: item.document_draft_id,
        keyword: this.keyword,
        _v: Math.random()
      }
      // this.$router.history.cb(_route)
      this.$router.replace(_route)
      this.currentValue = false
    },
    searchInput(val) {
      // console.log(val)
    },
    async clearInput() { // 清除按钮点击之后不触发搜索建议问题
      await this.$nextTick(() => {})
      this.$refs.searchInput.$el.querySelector('input').blur()
      await this.$nextTick(() => {})
      this.$refs.searchInput.focus()
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/scss/mixin.scss';
.autocompleteDisplay {
  display: none;
}
.autocompleteVisible {
  display: block;
}
.help-page-search {
  .el-dialog__body {
    padding: 0;
    padding-bottom: 48px;
  }
  .head {
    display: flex;
    padding: 0 48px;
    .wf-button-has {
      padding: 0 11px;
      margin-left: 8px;
    }
    .inline-input {
      display: block;
      width: 0;
      flex: 1;
    }
  }
  .tip {
    margin-top: 32px;
    padding: 0 48px;
    .title {
      color: rgba(32, 32, 32, 0.6);
      font-size: 14px;
      padding-bottom: 12px;
    }
    .item {
      height: 32px;
      padding: 0 16px;
      margin: 0 8px 8px 0;
      display: inline-flex;
      align-items: center;
      background: rgba(32,32,32,0.08);
      color: rgba(32, 32, 32, 0.8);
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        background-color: rgba(38, 130, 255, 0.10);
        color: #2682FF;
      }
    }
  }
  .result {
    margin-top: 32px;
    .title {
      color: rgba(32, 32, 32, 0.6);
      font-size: 14px;
      padding-bottom: 8px;
      padding: 0 48px;
      margin-bottom: 8px;
    }
    .detail-title {
      font-weight: 500;
      line-height: 18px;
      font-size: 16px;
      i {
        font-size: 16px;
        margin-right: 8px;
      }
    }
    .detail {
      @include ellipsis(4);
      line-height: 1.6;
      margin-top: 8px;
      font-size: 14px;
      color: rgba(32, 32, 32, 0.8);
    }
    .nothing-box-c {
      position: relative;
      min-height: 300px;
      .tip {
        padding: 0;
        margin-bottom: 0;
        margin-top: 12px;
      }
    }
    .content {
      overflow-x: hidden;
      overflow: overlay;
      max-height: 500px;
      padding-bottom: 8px;
      em {
        color: #2682FF;
      }
      .item {
        padding: 16px 48px;
        cursor: pointer;
        &:hover {
          background-color: rgba(32, 32, 32, 0.04);
        }
      }
      .loading-box {
        height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
